/*
  Design Craftsmanship — moodboard page.
  Adapted from a standalone HTML export (Claude Projects/sub pages/final
  pages/design-craftsmanship.html) for sections/design-and-craftsmanship.liquid.
  Behavior is unchanged from the export; queries are scoped to the .rd-craft
  wrapper (rather than the whole document) so this can't pick up unrelated
  ".item"-classed elements elsewhere on the page.
*/
(function () {
  'use strict';
  const wrapper = document.querySelector('.rd-craft');
  if (!wrapper) return;

  /* ----- wire per-item mobile widths (data-mw -> --mw) ----- */
  wrapper.querySelectorAll('.item[data-mw]').forEach(el => {
    if (el.dataset.mw) el.style.setProperty('--mw', el.dataset.mw);
  });

  /* ----- scroll reveal ----- */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const els = [...e.target.parentElement.querySelectorAll('.item')];
        const idx = els.indexOf(e.target);
        setTimeout(() => e.target.classList.add('revealed'), (idx % 5) * 110);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
  wrapper.querySelectorAll('.item').forEach(el => io.observe(el));

  /* ----- parallax (mouse + scroll), desktop only ----- */
  const fine = matchMedia('(pointer:fine) and (min-width:761px)').matches;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (fine && !reduced) {
    let mx = 0, my = 0, tx = 0, ty = 0;
    addEventListener('mousemove', e => {
      tx = (e.clientX / innerWidth - .5) * 2;
      ty = (e.clientY / innerHeight - .5) * 2;
    }, { passive: true });

    const items = [...wrapper.querySelectorAll('.item')].map(el => ({
      el, d: parseFloat(el.dataset.depth || 1)
    }));

    (function loop() {
      mx += (tx - mx) * .06;
      my += (ty - my) * .06;
      for (const { el, d } of items) {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > innerHeight + 200) continue;
        const drift = (r.top + r.height / 2 - innerHeight / 2) * (d - 1) * -0.035;
        el.style.transform = `translate3d(${mx * d * -10}px, ${my * d * -8 + drift}px, 0)`;
      }
      requestAnimationFrame(loop);
    })();
  }

  /* ----- cursor dot ----- */
  const cursor = wrapper.querySelector('.cursor');
  if (fine) {
    addEventListener('mousemove', e => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    }, { passive: true });
    wrapper.querySelectorAll('.item').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('grow'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('grow'));
    });
  } else {
    cursor.style.display = 'none';
  }
})();
